import axios from '@/api/axiosInstance';

export default async function recreateAccessToken() {
  const response = await axios({
    method: 'post',
    url: `${process.env.NEXT_PUBLIC_API}/auth/recreateAccessToken`,
  });
  return response.data;
}
